module.exports = __webpack_public_path__ + "img/f1.a92bfdf6.svg";